import { number, oneOfType, string } from 'prop-types';
import React from 'react';

import { mediaTypesShape } from '../../prop-types';
import Image from '../Image';
import Preview from '../Preview';
import { MEDIA_TYPES } from './constants';

function Thumbnail({ alt, id, previewSrc, src, maxWidth, type, ...rest }) {
  const isVideo = type === MEDIA_TYPES.VIDEO;
  const secondaryThumbnailSrc = isVideo
    ? '/images/video_thumb.jpg'
    : previewSrc;
  const srcs = [src, secondaryThumbnailSrc].filter(ea => ea);
  const key = `thumb-${id}`;

  return (
    <>
      <Image id={key} src={srcs} alt={alt} style={{ maxWidth }} {...rest} />
      <Preview target={key} src={previewSrc} type={type} />
    </>
  );
}

Thumbnail.propTypes = {
  alt: string,
  id: oneOfType([number, string]).isRequired,
  previewSrc: string.isRequired,
  src: string,
  maxWidth: number,
  type: mediaTypesShape.isRequired,
};

Thumbnail.defaultProps = {
  alt: undefined,
  src: undefined,
  maxWidth: 80,
};

export default Thumbnail;
